import { useCallback } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { StorageKey } from "config/storage";
import { authActions, User } from "slices/authSlice";
import { telemetry } from "telemetry";
import { mixpanel } from "utils/mixpanel";
import { saveToStorage } from "utils/storage";

export function useSetAuthState() {
    const dispatch = useAppDispatch();

    return useCallback(
        (accessToken: string, user: User) => {
            mixpanel?.identify(user.user);
            mixpanel?.people.set({
                "User Org": user.organization,
            });
            telemetry.identifyUser(user.user, { "user.org": user.organization });
            dispatch(authActions.login({ accessToken, user }));
            saveToStorage(StorageKey.AccessToken, accessToken);
        },
        [dispatch],
    );
}
